module.exports = __webpack_public_path__ + "static/media/certificate-bg.50a715a6.png";